import { render, staticRenderFns } from "./SuperAdminPark.vue?vue&type=template&id=88a0f6e6"
import script from "./SuperAdminPark.vue?vue&type=script&lang=js"
export * from "./SuperAdminPark.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports